import { Typography, Box, Container, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { convertToBase64 } from "../utils/helpers";
import { TipsAndUpdates } from "@mui/icons-material";

const ViewportAnalysis = ({ data }) => {

  useEffect(() => {
    const fetchImages = async () => {
      await convertToBase64(data.img_url);
    };

    fetchImages();
  }, [data]);
  return (
    <Container
      maxWidth="md"
      sx={{ border: "1px solid #E0E0E0", borderRadius: 1, pt: 4, pb: 8 }}
    >
      <Typography
        variant="h4"
        component="h1"
        textAlign={{ xs: "center", sm: "left" }}
        sx={{ mb: 4, color: "#4B5563", fontSize: "22px", fontWeight: "bold" }}
      >
        {data.title}
      </Typography>
      <img
        alt="viewport"
        src={data.img_url}
        style={{
          maxWidth: "100%",
          borderRadius: 5,
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
        }}
      />
      <Box sx={{ px: 3 }}>
        <Typography
          variant="h6"
          sx={{ mb: 2, mt: 4, fontSize: "19px", fontWeight: "550" }}
        >
          Observations:
        </Typography>
        <Stack spacing={1} sx={{ mb: 4 }}>
          {data.observations.map((item, index) => (
            <Typography
              key={index}
              variant="body1"
              color="text.secondary"
              sx={{ pl: { xs: 0, sm: 3 }, position: "relative" }}
            >
              • {item}
            </Typography>
          ))}
        </Stack>
      </Box>

      <Box sx={{ px: 3 }}>
        <Typography
          variant="h6"
          sx={{ mb: 2, fontSize: "19px", fontWeight: "550" }}
        >
          <TipsAndUpdates sx={{ mr: "5px", fontSize:"15px", color: "rgb(249, 181, 86)" }} />Recommendations:
        </Typography>
        <Stack spacing={1}>
          {data.reccos.map((recommendation, index) => (
            <Typography
              key={index}
              variant="body1"
              color="text.secondary"
              sx={{ pl: { xs: 0, sm: 3 }, position: "relative" }}
            >
              • {recommendation}
            </Typography>
          ))}
        </Stack>
      </Box>
    </Container>
  );
};

export default ViewportAnalysis;
